














































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class YearWheelEditor extends Vue {
  @Prop() subSlide: any;
  @Prop({ default: false }) readonly hideTitle!: boolean;

  months = [
    { name: 'Januari', index: 0 },
    { name: 'Februari', index: 1 },
    { name: 'Mars', index: 2 },
    { name: 'April', index: 3 },
    { name: 'Maj', index: 4 },
    { name: 'Juni', index: 5 },
    { name: 'Juli', index: 6 },
    { name: 'Augusti', index: 7 },
    { name: 'September', index: 8 },
    { name: 'Oktober', index: 9 },
    { name: 'November', index: 10 },
    { name: 'December', index: 11 },
  ];
  sortedMonths = this.months;
  startMonth: number = 0;

  @Watch('subSlide', { immediate: true, deep: true })
  subSlideChanged() {
    this.startMonth = this.subSlide.startMonth || 0;
    this.subSlide.texts = this.subSlide.texts || {};
    this.sortMonths();
  }

  sortMonths() {
    const start = this.months.filter((m) => m.index >= this.startMonth);
    const end = this.months.filter((m) => m.index < this.startMonth);
    this.sortedMonths = start.concat(end);
  }

  getItem(id: string) {
    return this.subSlide.texts[id] || '';
  }

  updateItem(id: string, value: string) {
    this.$set(this.subSlide.texts, id, value);
    this.$emit('update');
  }

  updateStartMonth() {
    this.$set(this.subSlide, 'startMonth', this.startMonth);
    this.$emit('update');
  }
}
